import styled from "styled-components";
import { Skeleton } from "../../../../../../structures/others/skeleton/index.js";
import { FlexMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
import { SearcherMiddle } from "../../../styled.js";
export const SkeletonSearcherMiddle = styled(SearcherMiddle).withConfig({
    displayName: "styled__SkeletonSearcherMiddle",
    componentId: "sc-67a77a02-0"
})`
	${FlexMixin({
    direction: 'column'
})}
`;
export const SearcherTop = styled.div.withConfig({
    displayName: "styled__SearcherTop",
    componentId: "sc-67a77a02-1"
})`
	${FlexMixin({})}
	gap: 16px;
	overflow: hidden;
	max-width: 100%;
`;
export const SkeletonItemTop = styled(Skeleton).withConfig({
    displayName: "styled__SkeletonItemTop",
    componentId: "sc-67a77a02-2"
})`
	overflow: visible;
	min-width: ${({ width  })=>width};
`;

//# sourceMappingURL=styled.js.map